import React, { useEffect, useRef } from 'react'
import ApexCharts from 'apexcharts'

function formatKey(key) {
    let words = key.split('total');
    let formattedWords = words.map(word => word.charAt(0).toUpperCase() + word.slice(1));
    let formattedKey = formattedWords.join(' ');
    return formattedKey;
}

const Charts = ({ data, title, id, total }) => {
    const { totalClientes, totalAnexos, totalFornecedores, ...chartData } = data;
    const seriesData = Object.keys(chartData).map(key => {
        return {
            name: formatKey(key),
            data: [chartData[key]]
        };
    });

    // Detectar tema escuro
    const isDarkMode = document.documentElement.getAttribute('data-theme') === 'dark';
    const textColor = isDarkMode ? '#ffffff' : '#4f46e5';
    const backgroundColor = isDarkMode ? 'transparent' : 'transparent';


    const options = {
        series: seriesData.map(item => item.data[0]), 
        labels: seriesData.map(item => item.name), 
        dataLabels: {
            enabled: true,
            formatter: function (val, opts) {
                return opts.w.config.series[opts.seriesIndex];
            },
            style: {
                fontSize: "12px",
                fontWeight: "bold",
            }
        },
        chart: {
            type: 'pie',
            height: 240,
            width: 280,
            fontSize: "14px",
            toolbar: {
                show: false, 
            },
            background: backgroundColor,
            foreColor: textColor
        },
        title: {
            text: title,
            align: 'center',
            style: {
                fontSize: "16px",
                fontWeight: "700",
                color: textColor
            }
        },
        colors: ['#142a4c', '#9ac31c', '#f59e0b', '#ef4444', '#1e3a6b'],
        legend: {
            position: 'bottom',
            fontSize: "14px",
            fontWeight: '600',
            labels: {
                colors: [textColor]
            }
        },
        plotOptions: {
            pie: {
                donut: {
                    size: '45%',
                    labels: {
                        show: true,
                        name: {
                            show: true,
                            fontSize: '16px',
                            fontWeight: 600,
                            color: textColor
                        },
                        value: {
                            show: true,
                            fontSize: '20px',
                            fontWeight: 700,
                            color: textColor
                        }
                    }
                }
            }
        },
    };

    const chartRef = useRef(null);

    useEffect(() => {
        if (chartRef.current) {
            chartRef.current.destroy();
        }
        chartRef.current = new ApexCharts(document.querySelector(`#${id}`), options);
        chartRef.current.render();
    }, [data]);

    return (
        <div id={id}></div>
    )
}

export default Charts
